import { createReducer } from "@reduxjs/toolkit";

import type { LoyaltyProfile } from "@app/types/loyalty";

import credit_cards from "./credit-cards";
import purchase from "./purchase";
import redeemable_amounts from "./redeemable-amounts";
import user_billing_address from "./user-billing-address";

export default {
  loyalty_profile: createReducer<LoyaltyProfile | null>(null, () => {}),
  redeemable_amounts,
  credit_cards,
  purchase,
  user_billing_address
};
